import React from "react";
import ForgotPasswordComponent from "../components/ForgotPasswordComponent";

function ForgotPasswordPage() {
  return (
    <>
      <ForgotPasswordComponent />
    </>
  );
}

export default ForgotPasswordPage;
